import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SwiperConfigInterface, SwiperDirective} from 'ngx-swiper-wrapper';
import {PressService} from '../../../providers/services/press.service';
import {Subscription} from 'rxjs';
import {Paths} from '../../../../config/config';

@Component({
  selector: 'app-homepage-news',
  templateUrl: './homepage-news.component.html',
  styleUrls: ['./homepage-news.component.scss']
})
export class HomepageNewsComponent implements OnInit, OnDestroy {

  @ViewChild(SwiperDirective, {static: false}) swiperDirective: SwiperDirective;
  public readonly Paths = Paths;

  public readonly swiper_news_home: SwiperConfigInterface = {
      autoplay: {
      delay: 5000
      },
      loop: false,
    freeMode: true,
    spaceBetween: 35,
    slidesPerView: 1.2,
    autoHeight: true,
    breakpointsInverse: true,
    navigation: false,
    pagination: {
      el: '.swiper-pagination-elsa',
      type: 'bullets',
      clickable: true,
    },
    mousewheel: false,
    watchOverflow: true,
    breakpoints: {
      768: {
        breakpointsInverse: true,
        spaceBetween: 25,
        slidesPerView: 2,
        freeMode: false,
        loop: true,
        navigation: false,
        pagination: {
          el: '.swiper-pagination-elsa',
          type: 'bullets',
          clickable: true,
        },
        watchOverflow: true,
      },
      992: {
        breakpointsInverse: true,
        spaceBetween: 25,
        slidesPerView: 3,
        freeMode: false,
        pagination: {
          el: '.swiper-pagination-elsa',
          type: 'bullets',
          clickable: true,
        },
        navigation: false,
        watchOverflow: true,
      },
      1200: {
        breakpointsInverse: true,
        spaceBetween: 25,
        slidesPerView: 4,
        freeMode: false,
        pagination: {
          el: '.swiper-pagination-elsa',
          type: 'bullets',
          clickable: true,
        },
        navigation: false,
        watchOverflow: true,
      }
    }
  };
  private readonly subscriptions: Subscription = new Subscription();

  public items;

  constructor(private pressService: PressService) {
    this.subscriptions.add(
      this.pressService.getArticlesInEvidence().subscribe(({body}) => {
        this.items = body.data.news.highlights;

        if (this.swiperDirective) {
          this.swiperDirective.update();
        }
      })
    );
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
